var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000014634037688172477980000002820039832160128191_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.2 32.2",
    style: {
      enableBackground: "new 0 0 32.2 32.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,2.4h-1.6c0-0.6-0.3-1.3-0.7-1.7S20.7,0,20.1,0h-8c-0.6,0-1.3,0.3-1.7,0.7C9.9,1.2,9.7,1.8,9.7,2.4H8 c-1.3,0-2.5,0.5-3.4,1.4S3.2,6,3.2,7.2v20.1c0,1.3,0.5,2.5,1.4,3.4s2.1,1.4,3.4,1.4h16.1c1.3,0,2.5-0.5,3.4-1.4s1.4-2.1,1.4-3.4 V7.2c0-1.3-0.5-2.5-1.4-3.4S25.4,2.4,24.1,2.4L24.1,2.4z M12.9,2.4h6.4c0.2,0,0.4,0.1,0.6,0.2C20,2.8,20.1,3,20.1,3.2V4 c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2h-6.4c-0.4,0-0.8-0.4-0.8-0.8V3.2C12.1,2.8,12.4,2.4,12.9,2.4L12.9,2.4z  M26.5,27.3c0,0.6-0.3,1.3-0.7,1.7c-0.5,0.5-1.1,0.7-1.7,0.7H8c-0.6,0-1.3-0.3-1.7-0.7c-0.5-0.5-0.7-1.1-0.7-1.7V7.2 c0-0.6,0.3-1.3,0.7-1.7C6.8,5.1,7.4,4.8,8,4.8h1.6c0,0.6,0.3,1.3,0.7,1.7C10.8,7,11.4,7.2,12,7.2h8c0.6,0,1.3-0.3,1.7-0.7 c0.5-0.5,0.7-1.1,0.7-1.7H24c0.6,0,1.3,0.3,1.7,0.7c0.5,0.5,0.7,1.1,0.7,1.7L26.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,22.5h-4.8c-0.4,0-0.8,0.2-1,0.6s-0.2,0.8,0,1.2c0.2,0.4,0.6,0.6,1,0.6h4.8c0.4,0,0.8-0.2,1-0.6 s0.2-0.8,0-1.2C16.5,22.7,16.1,22.5,15.7,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,16.9H10.9l0,0c-0.4,0-0.8,0.2-1,0.6s-0.2,0.8,0,1.2c0.2,0.4,0.6,0.6,1,0.6h10.5l0,0c0.4,0,0.8-0.2,1-0.6 s0.2-0.8,0-1.2C22.1,17.1,21.7,16.9,21.3,16.9L21.3,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,11.3H10.9l0,0c-0.4,0-0.8,0.2-1,0.6s-0.2,0.8,0,1.2s0.6,0.6,1,0.6h10.5l0,0c0.4,0,0.8-0.2,1-0.6 c0.2-0.4,0.2-0.8,0-1.2C22.1,11.5,21.7,11.3,21.3,11.3L21.3,11.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon22);
export default __webpack_public_path__ + "static/media/icon22.22db022d995ee7576f531d3a141d0ad2.svg";
export { ForwardRef as ReactComponent };